import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/tracking-consistency")({
  component: lazyRouteComponent(() => import("./-pages/admin.tracking-consistency")),
  head: () => ({
    meta: [
      { title: "Tracking Consistency · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
